<template>
    <div>
        <h2>Exam: <strong>{{examName}}</strong></h2>

        <p class="intro-text">
            Each two-page task is completed independently; but once you start a specific task, 
            you must complete it all at one time.  You may not save a partial task and return to it.
            Completed tasks will be greyed out. Before beginning your first task, review the <router-link to="help">Help</router-link>.
        </p>

        <p class="intro-text">
            Follow your instructor's direction with regard to when to complete each task.
        </p>

        <div v-if="allComplete">
            <hr>
            <h3>All tasks are complete!</h3>
            <hr> 
        </div>

        <div class="m-4" v-for="(task, index) in taskList" :key="task.id" v-b-tooltip.html.righttop="tooltipText(task.isCompleted, task.completedTime)">
            <b-button block variant="info" :disabled="task.isCompleted" 
                      @click="$router.push({ name: 'ExamTask', params: { examStudentTaskId: task.examStudentTaskId }})">
              Task {{index+1}}: <strong>{{task.taskName}}</strong>
            </b-button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TaskList',
    props: {
      examName: String,
      examStudentId: Number,
    },
    data() {
        return {
            taskList: Array
        }
    },
    computed: {
        allComplete: function() {
            if (this.taskList.length == 5) {
                var completedCounter = 0;
                for (var i = 0; i < 5; i++) {
                    if (this.taskList[i].isCompleted)
                        completedCounter++;
                }
                return completedCounter == 5;
            }
            return false;
        }       
    },
    mounted() {
        this.getTasks();
    },    
    methods: {
        getTasks() {
            this.$http
                .get('/examstudent/tasks')
                    .then(response => {
                        this.taskList = response.data; 
                    })
                    .catch(error => {
                        console.log(error);
                        //this.hasError = true;
                    });
        },
        tooltipText(isCompleted, completedTime) {
            if (isCompleted) {                
                var localTime = new Date(completedTime + 'Z');   
                var localTimeFormatted = localTime.toLocaleString('default', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute:'2-digit', hour12: true});
                return `Task Completed on:<br>${localTimeFormatted}`;
           }
           return "";
        }
    }
}
</script>

<style scoped>
    button {
        min-width: 200px;
    }
    .btn-info.disabled, .btn-info:disabled {
        color: #e7e7e7;
        background-color: #83adb4;
        border-color: #83adb4;
        cursor: not-allowed;        
    }
    .intro-text {
        font-size: 80%;
    }
</style>